import { createFileRoute } from "@tanstack/react-router";
import ListGrid from "@/components/organisms/lists/ListGrid";

const Lists = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Lists</h1>
      <ListGrid />
    </div>
  );
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/lists")({
  component: Lists,
});
